import { Info } from "lucide-react";

// Lightweight CSS-only hover/focus tooltip. No backend, no logic — purely explanatory.
export function InfoTip({ text, className = "" }) {
  return (
    <span className={`relative inline-flex group align-middle ${className}`} data-testid="info-tip" tabIndex={0}>
      <Info className="h-3.5 w-3.5 text-muted-foreground/70 cursor-help" />
      <span
        role="tooltip"
        className="pointer-events-none absolute left-1/2 bottom-full z-50 mb-1.5 w-56 -translate-x-1/2 rounded-md bg-slate-900 px-3 py-2 text-xs font-normal normal-case leading-snug text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 group-focus:opacity-100"
      >
        {text}
      </span>
    </span>
  );
}
